<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" id="inventoryModal" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="fw-semibold">Inventory Stock Details</h5>
            </div>
            <hr />
            <div class="card p-3 bgHightlight">
                <div class="row align-items-start">
                    <div class="col-12 col-lg-6">
                        <div class="panel-title">
                            <h6>{{'Vendor Inventory Stock Details' | wordReplace }}</h6>
                        </div>
                    </div>
                </div>
                <div class="row g-3 align-items-center mt-2">
                    <div class="col-12 col-lg-8 mt-0">
                        <div class="row g-2 align-items-center dealer-inputs">
                            <div class="col-12 col-md-6 col-lg-3">
                                <label class="form-label-small">{{'Vendor ID' | wordReplace }}</label>
                                <input type="text" class="form-control" [(ngModel)]="marketVendorId" name="VendorId"
                                    (ngModelChange)="onMarketVendorIdChange($event)">
                            </div>
                            <div class="col-12 col-md-6 col-lg-5">
                                <label></label>
                                <input type="text" class="form-control" [(ngModel)]="vendorName" name="VendorName">
                            </div>
                            <div class="col-auto mt-lg-4">
                                <button type="button" class="btn btnAS btnAS-sm" aria-label="search"
                                    (click)="openVendorSearchModal()">
                                    <img src="./assets/images/search.svg" class="img-fluid" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="checkbox-row">
                            <input class="form-check-input" type="checkbox" id="searchByDate" [(ngModel)]="searchByDate"
                                name="searchByDate" (ngModelChange)="onSearchByDateChanged()">
                            <label class="form-check-label ms-1" for="searchByDate">Search by Stock Received
                                Date</label>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-3">
                        <label class="form-label-small">Search By</label>
                        <select class="form-select" id="txtSearchField" [(ngModel)]="selectedSearchField"
                            name="searchField" (ngModelChange)="refreshInventoryData()">
                            <option [ngValue]="null" disabled>Select</option>
                            @for (option of searchFieldOptions; track option.id) {
                            <option [ngValue]="option.id">{{ option.name | wordReplace }}</option>
                            }
                        </select>
                    </div>

                    <div class="col-12 col-md-6 col-lg-3">
                        <label class="form-label-small">Search Value</label>
                        <input type="text" class="form-control" [(ngModel)]="searchValue" name="searchValue"
                            (ngModelChange)="onSearchValueChange($event)">
                    </div>

                    <div class="col-12 col-md-6 col-lg-3">
                        <label class="form-label-small">From</label>
                        <ejs-datepicker class="form-control p-0" [(ngModel)]="fromDate" name="fromDate"
                            [disabled]="!searchByDate" (ngModelChange)="refreshInventoryData()"
                            [max]="maxExpiryDate"></ejs-datepicker>
                    </div>

                    <div class="col-12 col-md-6 col-lg-3">
                        <label class="form-label-small">To</label>
                        <ejs-datepicker class="form-control p-0" [(ngModel)]="toDate" name="toDate"
                            [disabled]="!searchByDate" (ngModelChange)="refreshInventoryData()" [min]="minExpiryDate"
                            [max]="maxExpiryDate"></ejs-datepicker>
                    </div>
                </div>
            </div>
            <div class="card p-3 mt-2 bgHightlight">
                <div class="row">
                    <div class="col-md-6 text-start">
                        <h6>Stock Details</h6>
                    </div>
                    <div class="col-md-6 text-end">
                        <ejs-tooltip id='tooltipEditStockDetails' target="#btnStockEdit" position='TopCenter'
                            openMode="Auto" windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
                            <button id="btnStockEdit" type="button" class="btn btnAS me-1"
                                [disabled]="!hasSelectedRow()" (click)="openModalById('updateStockModal')"
                                [userPermissionHandler]="editPermissionHandlerData">
                                Edit
                            </button>
                        </ejs-tooltip>
                        <ejs-tooltip id='tooltipStockAddImage' target="#btnStockAddImage" position='TopCenter'
                            openMode="Auto" windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
                            <button id="btnStockAddImage" type="button" class="btn btnAS me-1"
                                [disabled]="!hasSelectedRow()" (click)="openModalById('addImageModal')"
                                [userPermissionHandler]="editPermissionHandlerData">
                                Add Image
                            </button>
                        </ejs-tooltip>
                        <ejs-tooltip id='tooltipStockReturn' target="#btnStockReturn" position='TopCenter'
                            openMode="Auto" windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
                            <button id="btnStockReturn" type="button" class="btn btn-orange me-1"
                                [disabled]="!hasSelectedRow()" (click)="openModalById('returnModal')"
                                [userPermissionHandler]="editPermissionHandlerData">
                                Return
                            </button>
                        </ejs-tooltip>
                        <ejs-tooltip id='tooltipStockReturnAll' target="#btnStockReturnAll" position='TopCenter'
                            openMode="Auto" windowCollision="fit" (beforeOpen)="onBeforeOpen($event)">
                            <button id="btnStockReturnAll" type="button" class="btn btnAS me-1"
                                [disabled]="!stockData || stockData.length === 0"
                                (click)="openModalById('returnAllModal')"
                                [userPermissionHandler]="editPermissionHandlerData">
                                Return All
                            </button>
                        </ejs-tooltip>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 text-start mt-2">
                        <ejs-grid #gridStockDetails [dataSource]="stockData" [height]="300" allowFiltering="true"
                            (created)='created($event)' (rowSelecting)="onRowSelecting($event)"
                            (rowSelected)="onRowSelected($event)">
                            <e-columns>
                                <e-column field="BarcodeId" [isPrimaryKey]="true" [visible]="false">
                                </e-column>
                                <e-column headerText="" field="pencil" width="35" textAlign="Center"
                                    allowFiltering="false">
                                    <ng-template #template let-data>
                                        <div class="row-select-indicator">
                                            <i *ngIf="isRowSelected(data)" class="fa fa-pencil-alt selected-pencil">
                                            </i>
                                        </div>
                                    </ng-template>
                                </e-column>
                                <e-column field="printBarcode" headerText="Print Barcode" width="125"
                                    textAlign="Center">
                                    <ng-template #template let-data>
                                        <div (click)="$event.stopPropagation();">
                                            <input type="checkbox" class="form-check-input"
                                                [checked]="data.printBarcode"
                                                (change)="onPrintLabelChange(data, $event)" />
                                        </div>
                                    </ng-template>
                                </e-column>
                                <e-column field="CategoryName" headerText="Category" width="160"></e-column>
                                <e-column field="StockId" headerText="Stock ID" width="140"></e-column>
                                <e-column field="ItemDescription" headerText="Item Description" width="220"></e-column>
                                <e-column field="Rate" headerText="Rate/ Unit" width="120" textAlign="Right"
                                    format="C2"></e-column>
                                <e-column field="CurrentStock" headerText="Current Stock" width="150"
                                    textAlign="Center"></e-column>
                                <e-column field="PurchaseCost" headerText="Purchase cost" textAlign="Right" width="150"
                                    format="C2"></e-column>
                                <e-column field="ReorderPoint" headerText="Reorder" width="100"
                                    textAlign="Center"></e-column>
                                <e-column field="CommissionRate" headerText="Comm%" width="120" format="N2"
                                    textAlign="Right"></e-column>
                                <e-column field="Count" headerText="Count" width="100" textAlign="Center" type="number">
                                    <ng-template #template let-data>
                                        <input class="form-control form-control-sm" style="text-align:right;width:100%;"
                                            [(ngModel)]="data.Count" [ngModelOptions]="{ standalone: true }"
                                            (keypress)="allowOnlyCountNumbers($event)" (blur)="formatCountInput(data)"
                                            (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                                            maxlength="3">
                                    </ng-template>
                                </e-column>
                                <e-column field="VendorDiscount" headerText="Disc%" width="100" format="N2"
                                    textAlign="Center"></e-column>
                                <e-column field="NoTax" headerText="No Tax" width="90" textAlign="Center">
                                    <ng-template #template let-data>
                                        <input type="checkbox" class="form-check-input" [checked]="data.NoTax"
                                            disabled />
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
                <div class="row mt-2 align-items-center" [formGroup]="barcodeTemplateForm">
                    <!-- Select All checkbox -->
                    <div class="col-md-2">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="chkSelectAll"
                                [(ngModel)]="selectAllPrintBarcode" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onSelectAllPrintBarcode()">
                            <label class="form-check-label" for="chkSelectAll">Select All</label>
                        </div>
                    </div>

                    <!-- Used Labels input -->
                    <div class="col-md-2 d-flex align-items-center">
                        <label for="usedLabels" class="form-label me-2 mb-0">Used Labels</label>
                        <input type="text" id="usedLabels" textStart="Center" class="form-control" style="width:80px;"
                            formControlName="UsedLabel" (keydown)="allowOnlyDigits($event, 2)"
                            (blur)="onUsedLabelBlur()">
                    </div>

                    <!-- Barcode Template dropdown -->
                    <div class="col-md-5 d-flex align-items-center">
                        <label for="barcodeTemplate" class="form-label me-2 mb-0">Barcode Template</label>
                        <select id="barcodeTemplate" class="form-select" style="width:270px"
                            formControlName="BarcodeTemplateId">
                            <option [value]="0" disabled selected>--Select Template--</option>
                            @for (b of barcodeTemplates; track b.BarcodeTemplateSettingId) {
                            <option [value]="b.BarcodeTemplateSettingId">
                                {{ b.TemplateName }}
                            </option>
                            }
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-end my-2">
                    <button class="btn btnAS me-1" (click)="onReportView()"
                        [disabled]="!barcodeTemplateForm.value.BarcodeIds">Print Selected Barcodes</button>
                    <!-- <button class="btn btnAS me-1">Save</button> -->
                    <button class="btn btn-orange" (click)="onStockDetailsCancel()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal with Vendor Search Component -->
<div class="modal fade" id="vendorSearchModal" #vendorSearchModal data-bs-parent="#inventoryModal" tabindex="-1"
    aria-labelledby="vendorSearchLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="vendorSearchLabel">
                    {{'Select Vendor' | wordReplace}}
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <app-vendor-search [isVendorPopUp]="true" [VendorFilterOption]="VendorFilterOption"
                    (vendorSearchRoute)="onVendorSelected($event)">
                </app-vendor-search>
            </div>
        </div>
    </div>
</div>
<!-- Modal for Add Image -->
<div class="modal fade" id="addImageModal" tabindex="-1" aria-labelledby="addImageModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="addImageModalLabel">Add Image</h1>
                <button type="button" class="btn-close" (click)="closeModalById('addImageModal')"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-6 col-lg-4 text-center">
                        <div class="imgBorder p-1">
                            <!-- <img src="./assets/images/gallery.svg" class="img-fluid" /> -->
                            <img [src]="logoPreviewUrl || './assets/images/gallery.svg'"
                                class="img-fluid rounded shadow-sm" alt="Inventory Image Preview"
                                style="width: 100%; height: 100%; object-fit: contain;" />
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-7 text-center">
                        <input type="file" id="imageInventoryFileInput" (change)="addInventoryImage($event)"
                            accept=".jpg,.jpeg,.png" hidden>
                        <button class="btn btnAS btnAS-sm" type="button" (click)="addLogoClick()">ADD</button>
                        <br />
                        <button class="btn btn-orange btnAS-sm mt-3" type="button" (click)="removeInventoryImage()"
                            [disabled]="!canRemoveInventoryImage">REMOVE</button>
                        <br />
                        <button class="btn btnAS btnAS-sm mt-3" type="button" (click)="saveInventoryImage()"
                            [disabled]="!canSaveInventoryImage">SAVE</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal for Return -->
<div class="modal fade" id="returnModal" tabindex="-1" aria-labelledby="returnModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="returnModalLabel">Return the Items</h1>
                <button type="button" class="btn-close" (click)="closeModalById('returnModal')"></button>
            </div>
            <div class="modal-body" [formGroup]="inventoryReturnForm">
                <div class="row g-3">
                    <div class="col-md-3">
                        <label for="category" class="form-label">Category</label>
                        <input type="text" class="form-control readonly-field" id="category"
                            [value]="selectedRow?.CategoryName" readonly>
                    </div>
                    <div class="col-md-3">
                        <label for="vendorStockId" class="form-label">{{ 'Vendor Stock ID' | wordReplace }}</label>
                        <input type="text" class="form-control readonly-field" id="vendorStockId"
                            [value]="selectedRow?.StockId" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="itemDescription" class="form-label">Item Description</label>
                        <input type="text" class="form-control readonly-field" id="itemDescription"
                            [value]="selectedRow?.ItemDescription" readonly>
                    </div>
                    <div class="col-md-2">
                        <label for="rateUnit" class="form-label">Rate / Unit</label>
                        <input type="text" class="form-control text-end readonly-field"
                            [value]="selectedRow?.Rate | currency" readonly>
                    </div>
                </div>

                <div class="row g-3 mt-2">
                    <div class="col-md-2">
                        <label for="currentStock" class="form-label">Current Stock</label>
                        <input type="number" class="form-control readonly-field" id="currentStock"
                            [value]="selectedRow?.CurrentStock" readonly>
                    </div>
                    <div class="col-md-2">
                        <label for="returnQty" class="form-label">Return Item Qty<span
                                class="text-danger">*</span></label>
                        <input type="number" class="form-control" id="returnQty" formControlName="ReturnQuantity">
                    </div>
                    <div class="col-md-8">
                        <label for="reasonReturn" class="form-label">Reason for return<span
                                class="text-danger">*</span></label>
                        <textarea class="form-control" id="reasonReturn" rows="2" formControlName="ReturnReason"
                            maxlength="50"></textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btnAS me-1" type="button" [disabled]="inventoryReturnForm.invalid"
                    (click)="saveReturnItem()">Save</button>
                <button class="btn btn-orange" (click)="closeModalById('returnModal')"
                    aria-label="Close">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal for Return All-->
<div class="modal fade" id="returnAllModal" tabindex="-1" aria-labelledby="returnAllModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="returnAllModalLabel">Return All the Items</h1>
                <button type="button" class="btn-close" (click)="closeModalById('returnAllModal')"></button>
            </div>
            <div class="modal-body">

                <!-- Step 1: Confirmation -->
                <div *ngIf="!showReturnAllReason" class="d-flex align-items-center p-3 bg-white">
                    <div class="me-3 text-warning fs-1">
                        <img src="./assets/images/warning.svg" class="img-fluid" />
                    </div>

                    <div>
                        <p class="mb-1 fw-medium">
                            Clicking this button will remove <b>{{ stockData.length }}</b> stock record(s)
                            belonging to vendor <b>{{ vendorName }}</b>, including all their items.
                        </p>
                        <p class="mb-0">Are you sure you want to continue?</p>
                    </div>
                </div>

                <!-- Step 2: Reason input -->
                <div *ngIf="showReturnAllReason" class="mt-2">
                    <label class="form-label">Reason for Return <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="returnAllReason" name="returnAllReason"
                        maxlength="50" />
                </div>
            </div>

            <div class="modal-footer">
                <!-- Step 1 buttons -->
                <ng-container *ngIf="!showReturnAllReason">
                    <button class="btn btnAS me-1" (click)="onConfirmReturnAll()">Yes</button>
                    <button class="btn btn-orange" (click)="closeModalById('returnAllModal')">No</button>
                </ng-container>

                <!-- Step 2 buttons -->
                <ng-container *ngIf="showReturnAllReason">
                    <button class="btn btnAS me-1" [disabled]="!returnAllReason || returnAllReason.trim() === ''"
                        (click)="submitReturnAll()">
                        Save
                    </button>
                    <button class="btn btn-orange" (click)="closeReturnAllModal()">Cancel</button>
                </ng-container>

            </div>
        </div>
    </div>
</div>
<!-- Modal for UpdateStockModal -->
<div class="modal fade" id="updateStockModal" tabindex="-1" aria-labelledby="updateStockModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <form [formGroup]="inventoryStockForm">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="updateStockModalLabel">Edit Item Details</h1>
                    <button type="button" class="btn-close" (click)="closeModalById('updateStockModal')"></button>
                </div>

                <div class="modal-body">
                    <div class="row g-2 align-items-center">
                        <!-- Category -->
                        <div class="col-md-3">
                            <label class="form-label">Category</label>
                            <select class="form-select" formControlName="CategoryId">
                                <option [value]="null" disabled selected>Select Category</option>
                                @for (category of productCategory; track category.CatSeqCategoryId) {
                                <option [value]="category.CatSeqCategoryId">
                                    {{ category.CatTxtCategoryDescr }}
                                </option>
                                }
                            </select>
                        </div>

                        <!-- Vendor Stock ID -->
                        <div class="col-md-2">
                            <label class="form-label">{{'Vendor Stock ID' | wordReplace}}</label>
                            <input type="text" class="form-control readonly-field" formControlName="StockId" readonly>
                        </div>

                        <!-- Item Description -->
                        <div class="col-md-3">
                            <label class="form-label">Item Description</label>
                            <input type="text" class="form-control" formControlName="ItemDescription" maxlength="100">
                        </div>

                        <!-- Rate / Unit -->
                        <div class="col-md-2">
                            <label class="form-label">Rate / Unit</label>
                            <input type="text" class="form-control text-end" formControlName="Rate" appCurrencyFormatter
                                value="$0.00" />
                        </div>

                        <!-- Current Stock -->
                        <div class="col-md-2">
                            <label class="form-label">Current Stock</label>
                            <input class="form-control text-center readonly-field" formControlName="CurrentStock"
                                readonly>
                        </div>
                    </div>

                    <div class="row g-2 mt-2 align-items-center">
                        <!-- Purchase ReOrder Cost -->
                        <div class="col-md-2">
                            <label class="form-label">Purchase Cost</label>
                            <input type="text" class="form-control text-end" formControlName="PurchaseCost"
                                appCurrencyFormatter value="$0.00" />
                        </div>

                        <div class="col-md-2">
                            <label class="form-label">Reorder Point</label>
                            <input class="form-control text-end" formControlName="ReorderPoint"
                                (keydown)="allowOnlyDigits($event, 3)" (blur)="onReorderBlur()">
                        </div>

                        <!-- Discount % -->
                        <div class="col-md-2">
                            <label class="form-label">Discount %</label>
                            <input type="text" class="form-control text-end" formControlName="VendorDiscount"
                                appPercentageFormatter value="0.00%" />
                        </div>

                        <!-- Commission % -->
                        <div class="col-md-2">
                            <label class="form-label">Commission %</label>
                            <input type="text" class="form-control text-end" formControlName="CommissionRate"
                                appPercentageFormatter value="0.00%" />
                        </div>

                        <!-- No Tax Checkbox -->
                        <div class="col-md-2 d-flex align-items-center mt-4 ">
                            <input type="checkbox" class="form-check-input me-2" formControlName="NoTax">
                            <label class="form-check-label">No Tax</label>
                        </div>

                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btnAS me-1" (click)="updateInventoryItem()"
                        [disabled]="!isUpdateItemSaveEnabled">Save</button>
                    <button type="button" class="btn btn-orange"
                        (click)="closeModalById('updateStockModal')">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>